import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import ContentComponent from './Content/Content'
import CurrentClientComponent from './CurrentClient/CurrentClient'
import CurrentUserComponent from './CurrentUser/CurrentUser'
import FooterComponent from './Footer/Footer'
import HeaderComponent from './Header/Header'
import InfoIconComponent from './InfoIcon/InfoIcon'
import LoadingComponent from './Loading/Loading'
import ModalChangePasswordComponent from './ModalChangePassword/ModalChangePassword'
import NavigationComponent from './Navigation/Navigation'
import PageComponent from './Page/Page'
import PageBottomBarComponent from './PageBottomBar/PageBottomBar'
import PageContentComponent from './PageContent/PageContent'
import PageFooterComponent from './PageFooter/PageFooter'
import PageHeaderComponent from './PageHeader/PageHeader'
import PageTabBarComponent from './PageTabBar/PageTabBar'
import PageToolbarComponent from './PageToolbar/PageToolbar'
import PageTopbarComponent from './PageTopBar/PageTopBar'
import PdfModalComponent from './PdfModal/PdfModal'
import FormModalComponent from './FormModal/FormModal'
import CaptchaComponent from './Captcha/Captcha'
import HistoryModalComponent from './HistoryModal/HistoryModal'
import BillingAlertComponent from "./BillingAlert/BillingAlert";
import CountdownComponent from './Countdown/Countdown'
import WhatsAppButtonComponent from './WhatsAppButton/WhatsAppButton'

export const Breadcrumbs = BreadcrumbsComponent
export const Content = ContentComponent
export const CurrentClient = CurrentClientComponent
export const CurrentUser = CurrentUserComponent
export const Footer = FooterComponent
export const Header = HeaderComponent
export const InfoIcon = InfoIconComponent
export const Loading = LoadingComponent
export const ModalChangePassword = ModalChangePasswordComponent
export const Navigation = NavigationComponent
export const Page = PageComponent
export const PageBottomBar = PageBottomBarComponent
export const PageContent = PageContentComponent
export const PageFooter = PageFooterComponent
export const PageHeader = PageHeaderComponent
export const PageTabBar = PageTabBarComponent
export const PageToolbar = PageToolbarComponent
export const PageTopBar = PageTopbarComponent
export const PdfModal = PdfModalComponent;
export const HistoryModal = HistoryModalComponent;
export const FormModal = FormModalComponent;
export const Captcha = CaptchaComponent;
export const BillingAlert = BillingAlertComponent;
export const Countdown = CountdownComponent
export const WhatsAppButton = WhatsAppButtonComponent
export { default as UploadProgressToast } from './UploadProgressToast/UploadProgressToast'


